import { FirebaseConfig } from './firebaseConfig';
import { HideDevTools } from './hide';

/* 'flow-outer-config' toggle is intentionally excluded - the nonlegal flow is disabled */
const features = [
    { id: 'hide-dev-tools', component: HideDevTools },
    { id: 'firebase-config', component: FirebaseConfig },
];

export default features;
